import React from 'react';
import './AboutUs.css';

const AboutUs: React.FC = () => {
  return (
    <div className="about-us">
      <div className="container">
        <div className="page-header">
          <h1>🐾 About Woofly</h1>
          <p>Meet the human and canine faces behind our mission</p>
        </div>

        {/* Mission Statement */}
        <section className="mission-statement">
          <div className="mission-content">
            <h2>Our Mission</h2>
            <p className="mission-text">
              "Paws United" — bringing communities together to help street dogs in India, 
              one city at a time. Woofly connects donors, brands, and compassionate citizens 
              with local dog welfare organizations, empowering them through visibility and direct support.
            </p>
          </div>
        </section>

        {/* Ira's Story */}
        <section className="ira-story">
          <div className="story-content">
            <div className="story-text">
              <h2>Meet Ira</h2>
              <h3>Founder of Woofly</h3>
              <p>
                Hi, I'm Ira, the founder of Woofly. My journey with street dogs began when 
                I visited India and was struck by the number of dogs living on the streets 
                without proper care or support.
              </p>
              <p>
                I was amazed by the work of the NGOs and the efforts they were putting in to help the dogs.
                I wanted to help them in any way I could. My initial idea was to create a hands on non profit 
                organization that would help the dogs in need. But I was stuck in the US while the dogs were 
                in India. So I decided to create a platform that would help the NGOs who WERE there for the dogs.
                I hope this platform will help nonprofits reach out to brands as well as people who want to help the dogs.

              </p>
              <div className="ira-quote">
                <blockquote>
                  "Animals are a part of our family. We must treat them with compassion and care."-Narendra Modi
                </blockquote>
              </div>
            </div>
            <div className="story-image">
              <div className="placeholder-image">
                👩‍💼
                <p>Ira's Photo</p>
              </div>
            </div>
          </div>
        </section>

        {/* Gabbar's Story */}
        <section className="gabbar-story">
          <div className="story-content">
            <div className="story-image">
              <div className="placeholder-image">
                🐕
                <p>Gabbar's Photo</p>
              </div>
            </div>
            <div className="story-text">
              <h2>Meet Gabbar</h2>
              <h3>Our Beloved Mascot</h3>
              <p>
                Gabbar is not just my dog — he's the inspiration behind Woofly and our 
                official mascot. He is an important part of my life and I am grateful for him.
              </p>
              <p>
                Unlike his name suggests he is a relitivly small dog. He is also the most popular person in our family.
                Everyone loves him a lot, he is also the reason why I started this organization. Many people do not understand the realation 
                and the love between a dog and a human. But the bond that I see with him is something that I want to share with the world.
                He will always be by my side and I will always be by his side. It hurts me to see other dogs in need and not be able to help them.
                Because I know that all dogs can have a speacial bond like Gabbar and I have.
              </p>
              <p>
                I know it is hard to open your heart to a dog. But I know that if you do, you will never regret it.
                I am not asking a lot from you. I am simply asking you to give them a chance.
                I know that you will not regret it. I know that you will love them as much as I do.
              </p>
              <div className="gabbar-facts">
                <h4>Fun Facts About Gabbar:</h4>
                <ul>
                  <li>🎾 Loves to distrupt our work(ex: sitting on keyboard, chewing wires, etc.)</li>
                  <li>🍖 Favorite treat: Cashews</li>
                  <li>🏃‍♂️ Enjoys having all the attention on him</li>
                  <li>😴 Expert at keeping us awake then sleeping the whole day</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">❤️</div>
              <h3>Compassion</h3>
              <p>Every decision we make is guided by love and empathy for animals</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Community</h3>
              <p>We believe in the power of people coming together for a common cause</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🔍</div>
              <h3>Transparency</h3>
              <p>We're committed to openness about our work and impact</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🌱</div>
              <h3>Sustainability</h3>
              <p>We build lasting solutions that create long-term positive change</p>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="team-section">
          <h2>Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-image">
                <div className="placeholder-image">👩‍💼</div>
              </div>
              <h3>Ira</h3>
              <p className="member-role">Founder & CEO</p>
              <p className="member-bio">
                Passionate about animal welfare and community building. 
                Leads Woofly's mission and strategic direction. Unites NGOs and brands to help street dogs.
              </p>
            </div>
            <div className="team-member">
              <div className="member-image">
                <div className="placeholder-image">🐕</div>
              </div>
              <h3>Gabbar</h3>
              <p className="member-role">Chief Happiness Officer</p>
              <p className="member-bio">
                Official mascot and inspiration. Provides unlimited cuddles 
                and keeps the team motivated with his wagging tail.
              </p>
            </div>
            <div className="team-member">
              <div className="member-image">
                <div className="placeholder-image">👥</div>
              </div>
              <h3>Our Volunteers</h3>
              <p className="member-role">NGOs and Volunteers</p>
              <p className="member-bio">
                Dedicated teams across India who make our mission possible 
                through their time, effort, resources and compassion.
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="contact-content">
            <h2>Get in Touch</h2>
            <p>Have questions or want to get involved? We'd love to hear from you!</p>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <div>
                  <h4>Email</h4>
                  <p>hello@woofly.org</p>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📱</span>
                <div>
                  <h4>WhatsApp</h4>
                  <p>+91 98765 43210</p>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <div>
                  <h4>Location</h4>
                  <p>Mumbai, India</p>
                </div>
              </div>
            </div>
            <button className="btn btn-primary">Send us a Message</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs; 